import { useEffect, useRef, useState } from 'react';
import { usePrevious } from '../../../../../../shared/hooks/previousValue';

export function useBookingCalendarHeightOffset(showFooter: boolean) {
    let [heightOffset, setHeightOffset] = useState<number>(0);
    let footerRef = useRef<HTMLElement>(null);
    let previousHeight = usePrevious(heightOffset);
    useEffect(() => {
        if (footerRef.current) {
            if (!showFooter) {
                setHeightOffset(0);
                return;
            }
            let newHeight = footerRef.current.offsetHeight;
            if (newHeight !== previousHeight) {
                setHeightOffset(newHeight);
            }
        }
    }, [heightOffset, showFooter]);

    return { heightOffset, footerRef };
}
